/**
 * 진행 위젯 타이틀 — 진행률 기반 고정 문구(피그마 사양). 데스크탑 위젯/모바일 bottom shell 공용.
 * 기존 "xxx님 리뷰에 댓글을 등록했어요"(IslandFeed) 피드 대신 이 고정 문구를 쓴다.
 * - 실패(job terminal 오류) → 오류 문구
 * - 완료 → 완료 문구
 * - 0% → 시작 문구 / ≥90% → 거의 완료 / 그 외 진행 중
 */
export const batchProgressTitle = (
  progress: number,
  isCompleted: boolean,
  isFailed: boolean,
): string => {
  if (isFailed) return 'AI 일괄 댓글 등록 중 오류가 발생했어요';
  if (isCompleted) return 'AI 일괄 댓글 등록이 완료되었어요';
  if (progress <= 0) return 'AI 일괄 댓글 등록이 시작되었어요';
  if (progress >= 90) return '등록이 거의 다 완료되었어요!';
  return 'AI 일괄 댓글 등록 중';
};
